import axios from '@/libs/api.request'
// 添加文书信息
export const subBillAdd = data => {
  return axios.request({
    url: '/bill/add',
    data,
    method: 'POST'
  })
}
// 获取文书信息列表
export const getBillList = data => {
  return axios.request({
    url: '/bill/list',
    data,
    method: 'POST'
  })
}
// 获取文书信息
export const getBillDetail = data => {
  return axios.request({
    url: '/bill/detail',
    data,
    method: 'POST'
  })
}
// 修改文书信息
export const subBillModify = data => {
  return axios.request({
    url: '/bill/modify',
    data,
    method: 'POST'
  })
}
// 获取上传文书显示的详情
export const getViewDetail = data => {
  return axios.request({
    url: '/bill/view/detail',
    data,
    method: 'POST'
  })
}
